import { render, staticRenderFns } from "./SitiosSistemas.vue?vue&type=template&id=574e4cb2&scoped=true"
import script from "./SitiosSistemas.vue?vue&type=script&lang=js"
export * from "./SitiosSistemas.vue?vue&type=script&lang=js"
import style0 from "./SitiosSistemas.vue?vue&type=style&index=0&id=574e4cb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574e4cb2",
  null
  
)

export default component.exports